import type { TypographyConfig } from '../../types/widget-types'
import { parseDataAttributes } from '../../utilities/utilities'

export type ProductVariantDataConfigStyles = {
  variantDataTypography?: TypographyConfig
}

export type ProductVariantDataAttributes = {
  selectedField: string
  facetCode?: string
  configStyles?: ProductVariantDataConfigStyles
}

/**
 * Parse ProductVariantData widget attributes from DOM data attributes.
 */
export function getProductVariantDataAttributes(attrs: NamedNodeMap): ProductVariantDataAttributes {
  const base = parseDataAttributes(attrs)

  const selectedFieldValue = base.selectedField
  const selectedField =
    typeof selectedFieldValue === 'string' && selectedFieldValue !== ''
      ? selectedFieldValue
      : 'name'

  const facetCodeValue = base.facetCode
  const facetCode =
    typeof facetCodeValue === 'string' && facetCodeValue !== '' ? facetCodeValue : undefined

  return {
    selectedField,
    facetCode,
    configStyles: base.configStyles as ProductVariantDataConfigStyles | undefined,
  }
}

export default function propsFn(dataAttributes: NamedNodeMap): ProductVariantDataAttributes {
  return getProductVariantDataAttributes(dataAttributes)
}
